import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { fetchReportNames } from './actionCreators';

interface InitialState {
  names: string[],
  isLoading: boolean,
  error: string,
}

const initialState: InitialState = {
  names: [],
  isLoading: false,
  error: '',
};

export const namesSlice = createSlice({
  name: 'names',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchReportNames.fulfilled.type]: (state, action: PayloadAction<string[]>) => {
      state.isLoading = false;
      state.error = '';
      state.names = action.payload;
    },
    [fetchReportNames.pending.type]: (state) => {
      state.isLoading = true;
    },
    [fetchReportNames.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export default namesSlice.reducer;
